import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'
import Main from '@/components/Main'
import Login from '@/components/Login'
import Faces from '@/components/Faces'
import FacesDetected from '@/components/FacesDetected'
import More from '@/components/More'
import Confirmed from '@/components/Confirmed'
import DomainSelector from '@/components/DomainSelector'
import FacesMatched from '@/components/FacesMatched'
import ModelValidator from '@/components/ModelValidator'
import MatchingTags from '@/components/MatchingTags'
import FaceImages from '@/components/FaceImages'
import FaceSimilarity from '@/components/FaceSimilarity'
import CLAHEValidator from '@/components/CLAHEValidator'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {path: '/faces/:person_name?', name: 'Faces', component: Faces},
    {path: '/detected/:frontend_face_uuid?', name: 'FacesDetected', component: FacesDetected},
    {path: '/more', name: 'More', component: More},
    {path: '/confirmed/:frontend_face_uuid?', name: 'Confirmed', component: Confirmed},
    {path: '/domainselector', name: 'DomainSelector', component: DomainSelector},
    {path: '/matched', name: 'Matched', component: FacesMatched},
    {path: '/modelvalidator', name: 'ModelValidator', component: ModelValidator},
    {path: '/matchingtags/:runtime_face_uuid', name: 'MatchingTags', component: MatchingTags},
    {path: '/faceimages', name: 'FaceImages', component: FaceImages},
    {path: '/facesimilarity', name: 'FaceSimilarity', component: FaceSimilarity},
    {path: '/clahevalidator', name: 'CLAHEValidator', component: CLAHEValidator},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js